import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig } from "../../../services/api-config";
import { API_SERVICE_ADDON_ROUTER } from "../../../services/api-config";

export enum ServiceAddonStatusCode {
  INACTIVE = 0,
  ACTIVE = 1,
  DELETED = 2,
}

export interface ServiceAddon {
  id: number;
  branch_id: number;
  code: string;
  name: string;
  description?: string;
  price?: number;
  status: ServiceAddonStatusCode | number;
  created_at?: string;
  updated_at?: string;
}

export interface ServiceAddonListResponse {
  list: ServiceAddon[];
  total_record: number;
  limit?: number;
}

export interface ServiceAddonListFilters {
  status?: number;
  branch_id?: number;
  store_id?: number;
  limit?: number;
  page?: number;
  key_search?: string;
}

export interface CreateServiceAddonPayload {
  branch_id: number;
  code: string;
  name: string;
  description?: string;
  price?: number;
  status?: ServiceAddonStatusCode;
}

export interface UpdateServiceAddonPayload {
  code?: string;
  name?: string;
  description?: string;
  price?: number;
  status?: ServiceAddonStatusCode;
}

export interface ChangeServiceAddonStatusPayload {
  status: ServiceAddonStatusCode;
}

export const ServiceAddonService = {
  list: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceAddonListResponse>({
       projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (params: ServiceAddonListFilters = { status: -1 }) =>
      request({
        endPoint: API_SERVICE_ADDON_ROUTER.API_LIST,
        data: params,
      }),
      response: baseResponse,
      loading: loading,
    }
  },

  create: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ServiceAddon>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (payload: CreateServiceAddonPayload) =>
        request({
          endPoint: API_SERVICE_ADDON_ROUTER.API_CREATE,
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ServiceAddon>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number, payload: UpdateServiceAddonPayload) =>
        request({
          endPoint: API_SERVICE_ADDON_ROUTER.API_CHANGE_PRICE_SERVICE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  changeStatus: () => {
    const { request, baseResponse, loading } = useFetchData.Post<ServiceAddon>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (id: number, payload: ChangeServiceAddonStatusPayload) =>
        request({
          endPoint: API_SERVICE_ADDON_ROUTER.API_CHANGE_STATUS_SERVICE(id),
          data: payload,
        }),
      response: baseResponse,
      loading: loading,
    }
  },

  detail: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceAddon>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return{
      fetch: (id: number) =>
        request({
          endPoint: API_SERVICE_ADDON_ROUTER.API_DETAIL_SERVICE(id),
        }),
      response: baseResponse,
      loading: loading,
    }
  },
  listActive: () => {
    const { request, baseResponse, loading } = useFetchData.Get<ServiceAddonListResponse>({
      projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
    });
    return {
      fetch: (params: ServiceAddonListFilters = { status: 1 }) =>
        request({
          endPoint: API_SERVICE_ADDON_ROUTER.API_LIST,
          data: params,
        }),
      response: baseResponse,
      loading: loading,
    }
  },
};

export default ServiceAddonService;
